import { Breakpoint } from '../utils/breakpoints';

export default {
  props: {
    modal: { type: Boolean },
    modalBreakpoint: {
      type: String,
      default: undefined,
      validator(v) {
        return (
          v === undefined || v === null || Object.values(Breakpoint).includes(v)
        );
      },
    },
    modalOptions: {
      type: Object,
      default: () => ({}),
    },
    modalTargetSlot: {
      type: String,
      default: 'default',
      validator(v) {
        return ['default', 'container', 'body'].includes(v);
      },
    },
    modalClass: {
      type: [String, Array, Object],
      default: undefined,
    },
  },
};
